"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpaceStation = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var SpaceStation = (function (_super) {
    __extends(SpaceStation, _super);
    function SpaceStation() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.SPACE_STATION,
            tags: [Tags_1.Tags.SPACE],
            cost: 10,
            cardDiscount: { tag: Tags_1.Tags.SPACE, amount: 2 },
            metadata: {
                cardNumber: '025',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.effect('When you play a Space card, you pay 2 M€ less for it.', function (eb) {
                        eb.space().played.startEffect.megacredits(-2);
                    });
                }),
                victoryPoints: 1,
            },
        }) || this;
    }
    SpaceStation.prototype.getCardDiscount = function (_player, card) {
        if (card.tags.includes(Tags_1.Tags.SPACE)) {
            return 2;
        }
        return 0;
    };
    SpaceStation.prototype.play = function () {
        return undefined;
    };
    SpaceStation.prototype.getVictoryPoints = function () {
        return 1;
    };
    return SpaceStation;
}(Card_1.Card));
exports.SpaceStation = SpaceStation;
//# sourceMappingURL=SpaceStation.js.map